// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"cc71fb00","78":"8abf1203","162":"e7a36eb0","165":"148036ab","221":"6dee524a","319":"63989bb4","385":"92f0ad44","386":"3a7971f5","429":"aeb99a87","488":"25b3e91d","493":"fdcbdb56","545":"3f80969a","682":"5de19a7c","928":"4e21ec6d","984":"86b5a78b"}[chunkId] + ".chunk.js";
};